import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { formatApiError } from '../../lib/api';
import Logo from '../../components/Logo';

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10"><Logo size="small" /></div>
        <h1 className="font-serif text-4xl text-navy text-center">Admin Portal</h1>
        <p className="font-sans text-sm text-navy/60 text-center mt-2">Sign in to edit site content</p>

        <form onSubmit={onSubmit} className="mt-10 space-y-5">
          <div>
            <label className="font-sans text-[11px] tracking-[0.3em] text-navy/60 block mb-2">EMAIL</label>
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              required autoFocus data-testid="login-email"
              className="w-full px-4 py-3 border border-navy/20 bg-cream2 focus:outline-none focus:border-navy font-sans text-navy"
            />
          </div>
          <div>
            <label className="font-sans text-[11px] tracking-[0.3em] text-navy/60 block mb-2">PASSWORD</label>
            <input
              type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              required data-testid="login-password"
              className="w-full px-4 py-3 border border-navy/20 bg-cream2 focus:outline-none focus:border-navy font-sans text-navy"
            />
          </div>
          {err && <p data-testid="login-error" className="font-sans text-sm text-red-700">{err}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full font-sans text-[11px] tracking-[0.3em] bg-navy text-cream px-6 py-3.5 hover:bg-navydark transition-colors disabled:opacity-60">
            {loading ? 'SIGNING IN…' : 'SIGN IN'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
